/**
 * Embed mode related signal names
 * @author Nachiket Kakatkar <nachiket@helpshift.com>
 * @created Feb 23, 2023
 * @module constants/hsdkMessageTypes
 */

export default {
  OPEN_ISSUE: "OPEN_ISSUE"
};
